import type { NumberCondition } from "@skilitics/judy";

import { isTernaryOperator, type NumericConditionValues } from "../../../effects-conditions/index.ts";
import type { ConditionBuilder, ConditionBuilderContext } from "../../../types";
import { createConditionBuildable } from "../../conditions";
import { RANDOM_RANGE_MAX, RANDOM_RANGE_MIN, RandomConditionEditor } from "./RandomConditionEditor";
import { RandomConditionSummary } from "./RandomConditionSummary";

interface RandomConditionContext extends ConditionBuilderContext {
  config: NumericConditionValues;
}

export const randomConditionBuilder: ConditionBuilder<RandomConditionContext> = {
  typeId: "random",
  defaultCategory: "Utility",
  build: ({ config: { operator, value, value2 }, resolvableValue }) => {
    if (!(operator && value !== undefined)) return;

    const condition = {
      type: "number",
      operator,
      subject: {
        type: "number",
        resolveType: "random",
        name: "number",
      },
    };

    if (isTernaryOperator(operator)) {
      if (value2 === undefined) return;

      const left = resolvableValue(value, "number");
      const right = resolvableValue(value2, "number");
      if (left === undefined || right === undefined) return;

      return { ...condition, left, right } as NumberCondition;
    }

    const object = resolvableValue(value, "number");
    if (object === undefined) return;

    return { ...condition, object } as NumberCondition;
  },

  views: {
    summary: RandomConditionSummary,
    edit: RandomConditionEditor,
  },
};

export const randomConditionBuildableCreate = () =>
  createConditionBuildable(randomConditionBuilder, "random-condition", {
    title: "Random",
    description: `A random number is generated between ${RANDOM_RANGE_MIN} and ${RANDOM_RANGE_MAX}`,
  });
